import { render, staticRenderFns } from "./WebshopProductItem.vue?vue&type=template&id=4cc1af16&"
import script from "./WebshopProductItem.vue?vue&type=script&lang=js&"
export * from "./WebshopProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports